import { render } from "./PublishComment.vue?vue&type=template&id=2841fe6e&scoped=true"
import script from "./PublishComment.vue?vue&type=script&lang=ts"
export * from "./PublishComment.vue?vue&type=script&lang=ts"

import "./PublishComment.vue?vue&type=style&index=0&id=2841fe6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2841fe6e"

export default script